import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.filter";
import "core-js/modules/es.object.define-property";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

var BindAccountModal = function (_super) {
  __extends(BindAccountModal, _super);

  function BindAccountModal() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.visible = false;
    _this.saveLoading = false;
    _this.formData = _this.initFormData();
    _this.formDataRule = {
      account_code: [{
        required: true,
        message: _this.t('请选择绑定主体'),
        trigger: 'change'
      }],
      shop_name: [{
        required: true,
        message: _this.t('请输入店铺名称'),
        trigger: 'blur'
      }, {
        min: 1,
        max: 50,
        message: _this.t('限制1~50字符'),
        trigger: 'blur'
      }]
    };
    return _this;
  }

  BindAccountModal.prototype.onVisibleChange = function (value) {
    if (!value) {
      var formDataRef = this.$refs.formDataRef;
      this.formData = this.initFormData();
      formDataRef && formDataRef.resetFields();
    }
  };

  BindAccountModal.prototype.onRecordChange = function (record) {
    this.formData = {
      customer_code: record.customer_code,
      account_code: record.account_code,
      shop_name: record.shop_name || ''
    };
  };

  Object.defineProperty(BindAccountModal.prototype, "availableBodyList", {
    get: function get() {
      var _this = this;

      return this.bodyList.filter(function (b) {
        return b.sign_body_status === _this.$enum.mine.SignBodyStatusEnum.ENABLED;
      });
    },
    enumerable: false,
    configurable: true
  });

  BindAccountModal.prototype.initFormData = function () {
    return {
      customer_code: undefined,
      account_code: undefined,
      shop_name: ''
    };
  };

  BindAccountModal.prototype.handleOk = function () {
    var _this = this;

    var formDataRef = this.$refs.formDataRef;
    formDataRef.validate(function (valid) {
      return __awaiter(_this, void 0, void 0, function () {
        var code;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              if (!valid) {
                return [2];
              }

              this.saveLoading = true;
              _a.label = 1;

            case 1:
              _a.trys.push([1,, 3, 4]);

              return [4, this.$api.shopManage.bindAccount({
                id: this.record.id,
                account_code: this.formData.account_code,
                shop_name: this.formData.shop_name
              })];

            case 2:
              code = _a.sent().code;

              if (code === 0) {
                this.$message.success(this.t('操作成功'));
                this.visible = false;
                this.$emit('success');
              }

              return [3, 4];

            case 3:
              this.saveLoading = false;
              return [7];

            case 4:
              return [2];
          }
        });
      });
    });
  };

  __decorate([Prop({
    type: Object,
    "default": function _default() {
      return {};
    }
  })], BindAccountModal.prototype, "record", void 0);

  __decorate([Prop({
    type: Array,
    "default": function _default() {
      return [];
    }
  })], BindAccountModal.prototype, "bodyList", void 0);

  __decorate([Watch('visible')], BindAccountModal.prototype, "onVisibleChange", null);

  __decorate([Watch('record')], BindAccountModal.prototype, "onRecordChange", null);

  BindAccountModal = __decorate([Component], BindAccountModal);
  return BindAccountModal;
}(Vue);

export default BindAccountModal;